module.exports = __webpack_public_path__ + "img/person-with-cart.b5013744.png";